export default __webpack_public_path__ + "static/media/helping-hands.03c0580f.svg";